<button class="generate-guid-button" mat-stroked-button color="accent" (click)="onGenerateGuid()">
  {{ buttonLabel }}
</button>
